import { Box, Table, Tbody } from "@chakra-ui/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import type { ViewDocumentAsOwnerDto } from "../../autogen/bff-api";
import { UploadRow } from "../../common/documents/UploadRow";
import { DropTarget } from "../../common/documents/UppyUploader/DropTarget";
import { isIncompleteFileUpload, type IncompleteFileUpload } from "../../common/documents/UppyUploader/FileRow";
import { useUppyUploader } from "../../common/documents/UppyUploader/useUppyUploader";

interface Props {
  needId: string;
  documents: ViewDocumentAsOwnerDto[];
  refetch: () => void;
}

export const NeedAttachmentUpload = ({ needId, documents, refetch }: Props) => {
  const { t } = useTranslation();
  const { uppy, allFiles, removeUpload, setDocuments } = useUppyUploader({
    entityId: needId,
    entityType: "Need",
    reloadEntity: refetch,
  });
  useEffect(() => {
    setDocuments(documents);
  }, [documents, setDocuments]);
  const uploads = allFiles.filter((f) => isIncompleteFileUpload(f)) as IncompleteFileUpload[];

  return (
    <Box>
      <DropTarget targetId="needFileTarget" uppy={uppy} helperText={t("Upload relevant documents")} paddingBottom="4" />
      {uploads.length > 0 && (
        <Table variant="simple" size="sm" mb="4">
          <Tbody>
            {uploads.map((d) => (
              <UploadRow key={d.uploadId} file={d} name={d.name} remove={removeUpload} />
            ))}
          </Tbody>
        </Table>
      )}
    </Box>
  );
};
